'use es6';

import ImmutableModel from 'DesignData/models/ImmutableModel';
import * as LayoutWidgetCSSParams from 'DesignData/enums/LayoutWidgetCSSParams';
import { uniqueId } from 'underscore';
/**
 * @class
 * @abstract
 */

export default class Widget extends ImmutableModel {
  /**
   * @constructor
   */
  constructor(props) {
    return super(props);
  }
  /**
   * @see {@link https://git.hubteam.com/HubSpot/template_builder/blob/0e086d176eeb22a07de575a6680620c65cc9e2c8/static/coffee/widget/models.coffee#L109}
   */


  static generateWidgetName() {
    return uniqueId(`${Widget.WIDGET_NAME_PREFIX}${Date.now()}`);
  }
  /**
   * @virtual
   */


  generateNewLayoutWidgetObject() {
    const {
      label,
      type
    } = this;
    const id = Widget.generateWidgetName();
    return {
      type: type || '',
      label: label || '',
      id,
      name: id,
      params: Object.assign({}, Widget.DEFAULT_CSS_PARAMS, {
        overrideable: false
      }),
      w: 12,
      x: 0,
      rows: []
    };
  }

  get isDisabled() {
    return false;
  }

}
/**
 * @type {String}
 * @const
 */

Widget.WIDGET_NAME_PREFIX = 'module_';
/**
 * @type {RegExp}
 * @const
 */

Widget.WIDGET_NAME_REGEX = /^module_\d+$/;
/**
 * @type {Array.<String>}
 * @const
 */

Widget.DEFAULT_CSS_FIELDS = Object.freeze(Object.values(LayoutWidgetCSSParams || {}));
/**
 * @type {Object.<String, String>}
 * @const
 */

Widget.DEFAULT_CSS_PARAMS = Object.freeze(Widget.DEFAULT_CSS_FIELDS.reduce((hash, field) => {
  hash[field] = '';
  return hash;
}, {}));